import {API_URL, jsonHeaders} from "./index";

export async function apiSendHelpRequest(message, phone) {
    const res = await fetch(`${API_URL}/help-request`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({message, phone})
    });
    return res.json();
}

export async function apiGetMyHelpRequests() {
    const res = await fetch(`${API_URL}/help-requests/mine`, {
        headers: jsonHeaders()
    });
    return res.json();
}

export async function apiAddHelpRequestMessage(requestId, content) {
    const res = await fetch(`${API_URL}/help-requests/${requestId}/messages`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({content})
    });
    return res.json();
}

export async function apiGetAllHelpRequests() {
    const res = await fetch(`${API_URL}/help-requests`, {
        headers: jsonHeaders()
    });
    return res.json();
}

export async function apiReplyHelpRequest(requestId, content) {
    const res = await fetch(`${API_URL}/help-requests/${requestId}/reply`, {
        method: "POST",
        headers: jsonHeaders(),
        body: JSON.stringify({content})
    });
    return res.json();
}

export async function apiCloseHelpRequest(requestId) {
    const res = await fetch(`${API_URL}/help-requests/${requestId}/close`, {
        method: "PATCH",
        headers: jsonHeaders()
    });
    return res.json();
}
